import { apiClient } from "@lib/axios";

export const notionApi = {
  publishTemplates: async ({ signal }: { signal: AbortSignal }) => {
    return await apiClient.get("/assets-deployment/publish-templates", {
      signal,
    });
  },
  publishLinks: async ({ signal }: { signal: AbortSignal }) => {
    return await apiClient.get("/assets-deployment/publish-links", { signal });
  },
  publishStoryExamples: async ({ signal }: { signal: AbortSignal }) => {
    return await apiClient.get("/assets-deployment/publish-story-examples", {
      signal,
    });
  },
};
